var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("华熙国际投资集团保留法律许可范围内所有解释权　版权所有©华熙国际投资集团有限公司")])])
}]

export { render, staticRenderFns }